import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { CookieService } from 'ngx-cookie';

import { APP_CONFIG, AuthStatus } from '@bn/primitives';

import { AuthRoutes } from '../enums/auth-routes.enum';
import { AuthService } from '../services/auth.service';
import { FluffeeService } from '../services/fluffee.service';
import { UserDetailsStateService } from '../services/user-details-state.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  readonly #APP_CONFIG = inject(APP_CONFIG);
  readonly #router = inject(Router);
  readonly #userDetailsService = inject(UserDetailsStateService);
  readonly #fluffeeService = inject(FluffeeService);
  private readonly authService = inject(AuthService);
  private readonly cookie = inject(CookieService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const authData = this.authService.authStoreValue;
    const user = route.queryParams.user;

    if (authData?.auth_token && authData?.auth_status === AuthStatus.Authenticated) {
      this.#userDetailsService.getFreshUserDetails().subscribe((userDetails) => {
        this.#userDetailsService.initUserDetailsInterval();
        this.#fluffeeService.initFluffee(userDetails.Id, (authData?.auth_token as string) ?? '');

        const extAuthIntermediateCookieValue = this.cookie.get(this.#APP_CONFIG.extAuthCookieName);

        if (extAuthIntermediateCookieValue) {
          // const extAuthIntermediateQueryData = JSON.parse(extAuthIntermediateCookieValue);

          // if (sanitizeReturnUrl(extAuthIntermediateQueryData.callbackUrl) && this.route.snapshot.queryParams.returnFromSSO) {
          //   this.router.navigate(['/', AppRoutes.ExtAuth], {
          //     queryParams: extAuthIntermediateQueryData,
          //   });
          // }
          this.cookie.remove(this.#APP_CONFIG.extAuthCookieName);
        }
      });

      // authorised so return true
      return true;
    }

    // Redirect to 2fa page if needed
    if (authData?.auth_token && authData?.auth_status === AuthStatus.TwoFactorRequired) {
      this.#router.navigate([`/${AuthRoutes.Auth}/${AuthRoutes.TwoFactorAuth}`], {
        queryParams: { returnUrl: state.url, user },
      });

      return false;
    }

    // not logged in so redirect to login page with the return url
    this.#router.navigate([`/${AuthRoutes.Auth}/${AuthRoutes.Login}`], {
      queryParams: { returnUrl: state.url, user },
    });

    return false;
  }
}
